import { DomainStatus } from '@anm/api/modules/customDomains';
import { flexCenter } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

const flexAlign = css`
  display: flex;
  align-items: center;
`;

export const ListWrapper = styled.div`
  margin: 20px 0 12px 0;
`;

export const ListHead = styled.div`
  ${flexAlign};
  margin-bottom: 4px;
  font-size: 14px;
  line-height: 22px;
  color: #919eaa;
`;

export const ListItemWrapper = styled.div`
  ${flexAlign};
  min-height: 45px;

  &:not(:first-child):not(:last-child) {
    border-bottom: 1px solid rgba(0, 56, 87, 0.2);
  }
`;

export const LeftColumn = styled.div`
  width: 235px;
  padding-right: 10px;

  span {
    font-size: 14px;
    color: #292a2b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:before {
      flex-shrink: 0;
    }
  }
`;

export const RightColumn = styled.div`
  flex-shrink: 0;
  flex-grow: 1;
  ${flexAlign};
  justify-content: space-between;
`;

export const StatusLabel = styled.div<{ status: DomainStatus }>`
  ${flexCenter};
  min-height: 20px;
  min-width: 71px;
  font-size: 13px;
  line-height: 16px;
  color: #575c5e;
  border-radius: 4px;
  background: ${({ status }) => (status === 'OK' ? 'var(--green_bkb)' : '#E9EEF1')};
`;
